import {
  CHECK_DUPLICATED_PHONE_REQUEST,
  CHECK_DUPLICATED_PHONE_SUCCESS,
  CREATE_POST_PRESIGNED_REQUEST,
  CREATE_POST_PRESIGNED_SUCCESS,
  GET_DOC_BUFFERED_DATA,
  GET_EAPP_PROCESS_HISTORY_DATA,
  GET_LIST_OF_VALUE_DATA,
  GET_TRACKING_REQUEST,
  GET_TRACKING_SUCCESS,
  REGISTER_BY_RECRUITER_REQUEST,
  REGISTER_BY_RECRUITER_SUCCESS,
  SET_EAPP_PROCESS_HISTORY_DATA,
  SET_EPROMOTION_AM_CANDIDATE_ID,
  SET_LIST_OF_VALUE_DATA,
} from './constants';

const getListOfValueDataAction = (payload) => ({
  type: GET_LIST_OF_VALUE_DATA,
  payload,
});

const setListOfValueDataAction = (payload) => ({
  type: SET_LIST_OF_VALUE_DATA,
  payload,
});

const registerByRecruiterRequest = (payload, callback) => ({
  type: REGISTER_BY_RECRUITER_REQUEST,
  payload,
  callback,
});
const registerByRecruiterSuccess = (payload) => ({
  type: REGISTER_BY_RECRUITER_SUCCESS,
  payload,
});

const checkDuplicatedPhoneRequest = (payload, callback) => ({
  type: CHECK_DUPLICATED_PHONE_REQUEST,
  payload,
  callback,
});
const checkDuplicatedPhoneSuccess = (payload) => ({
  type: CHECK_DUPLICATED_PHONE_SUCCESS,
  payload,
});

const createPostPresignedRequest = (payload, callback) => ({
  type: CREATE_POST_PRESIGNED_REQUEST,
  payload,
  // callback,
});
const createPostPresignedSuccess = () => ({
  type: CREATE_POST_PRESIGNED_SUCCESS,
});

const getTrackingRequest = (payload) => ({
  type: GET_TRACKING_REQUEST,
  payload,
});
const getTrackingSuccess = (payload) => ({
  type: GET_TRACKING_SUCCESS,
  payload,
});

const getEappProcessHistoryDataAction = (payload) => ({
  type: GET_EAPP_PROCESS_HISTORY_DATA,
  payload,
});

const setEappProcessHistoryDataAction = (payload) => ({
  type: SET_EAPP_PROCESS_HISTORY_DATA,
  payload,
});

const getDocBufferedDataAction = (payload, callback) => ({
  type: GET_DOC_BUFFERED_DATA,
  payload,
  callback,
});

const setEPromotionAmCandidateId = (payload) => ({
  type: SET_EPROMOTION_AM_CANDIDATE_ID,
  payload,
});

export {
  setEPromotionAmCandidateId,
  getListOfValueDataAction,
  setListOfValueDataAction,
  registerByRecruiterRequest,
  registerByRecruiterSuccess,
  checkDuplicatedPhoneRequest,
  checkDuplicatedPhoneSuccess,
  createPostPresignedRequest,
  createPostPresignedSuccess,
  getTrackingRequest,
  getTrackingSuccess,
  setEappProcessHistoryDataAction,
  getDocBufferedDataAction,
};
